export default "__VITE_ASSET__C$G2ERoN__"